import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { ExtensionTypes } from 'generated/graphql-types';
import { ExtensionDetailFormValue } from '../../extension-details/models/extension-detail-form';
import { ExtensionTypeOption } from '../../extension-register/models/extension-type-option.interface';
import { LocationDetailFormValue } from '../../location-details/models/location-detail-form';
import { PhoneNumberDetailFormValue } from '../../phone-number-details/models/phone-number-detail-form';
import { AccountExtensionView } from '../add-account-extension/models/account-extension-view.model';
import { AccountPhoneNumberView } from '../add-account-phone-numbers/models/account-phone-number-view.model';
import { AddAccountData } from '../models/add-account-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-account-view',
    styleUrls: ['./add-account-view.component.scss'],
    templateUrl: './add-account-view.component.html',
    standalone: false
})
export class AddAccountViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddAccountData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Output() addExtension = new EventEmitter<ExtensionTypeOption>();

   @Output() editExtension = new EventEmitter<AccountExtensionView>();

   @Output() removeExtension = new EventEmitter<{ extensionNumber: number; phoneNumbers: AccountPhoneNumberView[] }>();

   @Output() addPhoneNumber = new EventEmitter<boolean>();

   @Output() addLocation = new EventEmitter<void>();

   @Output() editLocation = new EventEmitter<LocationDetailFormValue>();

   @Input() form: UntypedFormGroup;

   @Input() locationRequired: boolean;

   extensionTypesToInclude: string[] = [
      ExtensionTypes.HuntGroup,
      ExtensionTypes.Fax,
      ExtensionTypes.VoiceMailbox,
      ExtensionTypes.AutoAttendant,
      ExtensionTypes.ExternalForward,
   ];

   private _createExtensionTypeOptions: ExtensionTypeOption[] | null;

   @Input() set createExtensionTypeOptions(extensionTypeOptions: ExtensionTypeOption[] | null) {
      if (extensionTypeOptions != null && extensionTypeOptions.length > 0) {
         this._createExtensionTypeOptions = extensionTypeOptions.filter((extTypeOption) => {
            return this.extensionTypesToInclude.includes(extTypeOption.name);
         });
      }
   }

   get createExtensionTypeOptions() {
      return this._createExtensionTypeOptions;
   }

   addExtensionCount: number | null;

   addExtensionType: ExtensionTypeOption | null;

   addedExtensions: ExtensionDetailFormValue[] = [];

   addPhoneNumberCount: number | null;

   addedPhoneNumbers: PhoneNumberDetailFormValue[] = [];

   onRemoveExtension(extensionNumber: number): void {
      const phoneNumbers = this.form.get('newPhoneNumbers')?.value || [];
      const phoneNumbersUsingExtension = phoneNumbers.filter(
         (phone: AccountPhoneNumberView) => phone.routeTo?.number === extensionNumber
      );

      this.removeExtension.emit({ extensionNumber, phoneNumbers: phoneNumbersUsingExtension });
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }

   addExtensionClick(extensionTypeOption: ExtensionTypeOption) {
      this.addExtension.emit(extensionTypeOption);
   }

   onEditClicked(extension: AccountExtensionView) {
      this.editExtension.emit(extension);
   }

   addPhoneNumberClick(isNew: boolean) {
      this.addPhoneNumber.emit(isNew);
   }

   addLocationClick() {
      this.addLocation.emit();
   }

   editLocationClick(location: LocationDetailFormValue) {
      this.editLocation.emit(location);
   }
}
